import { IGlobalSearchResponse } from "@src/types/api/global-search";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
// import { fetchGlobalSearch } from "./callback";
import { TResponse } from "../../../types/common";
import { fetchGlobalSearch } from "./callback";






export const useGlobalSearch = (query: string) : UseQueryResult<TResponse<IGlobalSearchResponse>, Error> => {
  return useQuery<TResponse<IGlobalSearchResponse>>({
    queryKey: [API_ENDPOINTS.GLOBAL_SEARCH, query],
    queryFn: async () => {
        const res = await fetchGlobalSearch(query); 
        return res.data;
    },
    enabled: query.trim().length > 1, // important
    staleTime: 1000 * 30,
  });
};